import { render, staticRenderFns } from "./editSmallWeChat.vue?vue&type=template&id=0216a484"
import script from "./editSmallWeChat.vue?vue&type=script&lang=js"
export * from "./editSmallWeChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports